/**
 * the function removes "%" from the value and converts to a number
 */
export function getNumberFromPercentValue(value: string| number): number {
  if (typeof value === 'string')
    return Number(value.replace('%', ''))

  return value
}